import React from 'react';
import { connect } from 'react-redux';

import { REDUCER_NAME } from 'src/reducers/employees/employees';
import { EMPLOYEE_EDIT } from 'src/constants/EndpointUrls';
import { concatParamsToUrl } from 'src/utils/Http';
import { setItem } from 'src/reducers/common/itemReducer';
import SettingSideBar from './components/SettingSideBar';
//import EmployeeFromAdminForm from './components/EmployeeFromAdminForm';
import SimpleProfileShow from './components/SimpleProfileShow';
import { useTranslation } from 'react-i18next';

const EditProfile = ({ dispatch, employee }) => {
  const { t } = useTranslation();
  dispatch(setItem(REDUCER_NAME, { employee }));
  const editUrl = concatParamsToUrl(EMPLOYEE_EDIT, { id: employee.id });
  

  return (
    <div className="l-wrap-l">
      <h2 className="m-title-sub">{t('features.Users.components.SettingSideBar.profile')}</h2>
      <div className="l-flex">
        <div className="l-flex3-sub">
          <SettingSideBar />
        </div>
        <div className="l-flex3-main">
          <SimpleProfileShow editUrl={editUrl} /> 
        </div>
      </div>
    </div>
  );
};

export default connect()(EditProfile);
